import _series_helper from "./_series_helper"
import http_helper from "../../base/http_helper"
import spinners from "../../components/loader/spinners"

const _CHART =  {
    period: 24,
    chart_id: undefined,
    generate(options){
        this.setStage(options.container)
        this.showOverlay(options.container)
        http_helper.request('/sibh/api/v1/measurements/time_ago_grouped', {station_prefix_ids:[CURRENT_STATION.id], time: options.period, time_type: 'hour', group_type:'hour'},'POST').then(data=>{
            this.period = options.period
            if(data.json.length > 0){
                if(CURRENT_STATION.station_type_id == 1){
                    this.generateChartFlu(data.json, options.container, CURRENT_STATION)
                } else {
                    this.generateChart(data.json, options.container, CURRENT_STATION)
                }
            } else {
                this.hideOverlay(options.container)
                this.generateMessage('nodata')
            }
            
            
        })
    },
    generateMessage(type){
        if(type == 'nodata'){
            $("#"+this.chart_id).html("<div style='display: flex;align-items: center;justify-content: center;flex-direction: column'><div style='font-size:xxx-large'><i class='far fa-sad-tear'></i></div><div>Sem dados no período selecionado</div></div>")
        }
    },
    generateChart(measurements, chart_container,station_prefix){
        let titles = this.generateTitles(station_prefix)
        let chart = new Highcharts.Chart({
            chart: {
              renderTo: this.chart_id,
              type: 'column',
              zoomType: "x"
            },
            title: {
                text: titles.title
            },
            subtitle: {
                text: titles.subtitle
            },
            xAxis: {
                type: 'datetime',
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Chuva (mm)'
                },
                labels: {
                  format: '{value}'
                }
            },
            tooltip: {
                shared: true,
                formatter: function (e) {
                    //console.log(this)
                    let html = '<b>' + moment(this.x).format('DD/MM HH:mm') + '</b><br>'
                    $.each(this.points, function(index, point){
                        let text = ""
                        let id = point.series.userOptions.id
                        if(id == "event"){
                            text += "Evento de chuva: "
                        } else if(id == "accumulated"){
                            text += "Chuva Acumulada: "
                        }
                        if(id != 'flaws'){
                            text += '<b><span style="color:'+ point.color +'">' + point.y +' mm</span></b><br/>'
                        } else {
                            text += 'Falha: <b><span style="color:'+ point.color +'">' + point.total +' minutos</span></b><br/>'
                        }
                        
                        html += text;
                    })
                    return html
                },
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
                series: {
                  cursor: 'pointer',
                }
            
            },
            series: this.generateSeries(measurements),
            credits: {
                enabled: false
            }
              
        })
        this.hideOverlay(chart_container)
    },
    generateChartFlu(measurements, chart_container,station_prefix){
        let titles = this.generateTitles(station_prefix)
        let plotlines = this.generatePlotLines(measurements)
        let plotlines_copy = JSON.parse(JSON.stringify(plotlines)); //duplicando plot lines por que o método removePlotLine destrói a plotline. Como a listagem de plotlines é referenciada, ela é destruida na call do método. Essa copia serve para a reconstrução das plots
        let chart = new Highcharts.Chart({
            chart: {
              renderTo: this.chart_id,
              type: 'line',
              zoomType: "x",
            },
            title: {
                text: titles.title
            },
            subtitle: {
                text: titles.subtitle
            },
            xAxis: {
                type: 'datetime',
                crosshair: true,
            },
            yAxis: [
                {
                    title: {
                        text: 'Cota (cm)'
                    },
                    labels: {
                        format: '{value}'
                    },
                    //plotLines: plotlines['level'],
                    id: 'level'
                },
                {
                    title: {
                        text: 'Vazão (m³/s)'
                    },
                    labels: {
                        format: '{value}'
                    },
                    //plotLines: plotlines['flow'],
                    opposite: true,
                    id:'flow'
                }
            ],
            tooltip: {
                shared: true,
                formatter: function (e) {
                    let html = '<b>' + moment(this.x).format('DD/MM HH:mm') + '</b><br>'
                    $.each(this.points, function(index, point){
                        let text = ""
                        let id = point.series.userOptions.id
                        if(id == "event"){
                            text += 'Cota: <b><span style="color:'+ point.color +'">' + point.y +' cm</span></b><br/>'
                        } else if(id == "flow"){
                            text += 'Vazão: <b><span style="color:'+ point.color +'">' + point.y +' m³/s</span></b><br/>'
                        } else if(id == 'flaws'){
                            text += 'Falha: <b><span style="color:'+ point.color +'">'+_CHART.flawHumanize(point.total)+'</span></b><br/>'
                        }                  
                        html += text;
                    })
                    return html
                },
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
                series: {
                  cursor: 'pointer',
                  events: {
                    legendItemClick: function () {
                        if(this.userOptions.id == 'params'){
                            if(this.visible){
                                $.each(chart.yAxis, function(index, yaxi){
                                    yaxi.removePlotLine('param'); //id das plotlines
                                })
                                return true
                            } else {
                                $.each(chart.yAxis, function(index, axi){
                                    let plots = plotlines_copy[axi.userOptions.id]
                                    $.each(plots, function(index, plot){
                                        axi.addPlotLine(plot)
                                    })
                                })
                            }
                        }
                    }
                  }
                }
            
            },
            series: this.generateSeriesFlu(measurements),
            credits: {
                enabled: false
            }
              
        }) 
        this.hideOverlay(chart_container)
        
    },
    generateSeries(measurements){
        let series = [];
        if(measurements.length > 0){
            series.push(
                {
                    name: "Leitura",
                    data: measurements.map(x=>[moment(x.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(x.value.toFixed(1))]),
                    id:"event"
                }
            );
            
            let accumulated_series = []
            let current_sum = 0;
            $.each(measurements, function(index, measurement){
                current_sum += measurement.value
                accumulated_series.push([moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(current_sum.toFixed(1))])
            })         
            
            let flaws = this.getFlaws(series, measurements, 24, 60)
            if(CURRENT_STATION.station_type_id == 1){
                accumulated_series = this.fillSeriesWithFlaws(flaws,accumulated_series)
                flaws = this.fillFlawsWithValues(flaws, accumulated_series)
            }

            series.push(
                {
                    name: "Chuva Acumulada",
                    data: accumulated_series,
                    type: 'line',
                    id: "accumulated",
                    zIndex:1
                }
            );
            let data = []
            $.each(flaws, function(index, flaw){
                data.push({x:flaw[0], y:flaw[2], total: flaw[4]}) //inicio falha
                data.push({x:flaw[1], y:flaw[3], total: flaw[4]}) //fim falha
                data.push({x:flaw[1]+1, y:null})
            })
            //adicionando falhas caso posto fluviométrico
            if(CURRENT_STATION.station_type_id == 1){
                series.push(
                    {
                        name: "Falhas",
                        data: data,
                        type: 'line',
                        id: "flaws",
                        color: 'red',
                        dashStyle: 'ShortDash',
                        zIndex: 0,
                        lineWidth:1
                    }
                );
            }
            
            
        }
        console.log(series);
        return series
    },
    generateSeriesFlu(measurements){
        let series = [];
        console.log('medições', measurements)
        if(measurements.length > 0){
            let flaws = this.getFlaws(series, measurements, this.period, 60)
            let level_data = measurements.map(x=>[moment(x.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(x.value.toFixed(3))])
            level_data = this.fillSeriesWithFlaws(flaws,level_data)            
            series.push(
                {
                    name: "Cota",
                    data: level_data,
                    color:'#0ddb22',
                    id:"event"
                }
            );
            series.push(
                {
                    name: 'Vazão',
                    data: measurements.map(x=>[moment(x.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(x.read_value_flu)]),
                    id:"flow",
                    color:'#e31296',
                    yAxis: 1
                }
            );        
            flaws = this.fillFlawsWithValues(flaws, level_data)
            series.push(
                {
                    name: "Limiares",
                    data: [],
                    id: "params",
                    visible: false
                }
            );
            let data = []
            $.each(flaws, function(index, flaw){
                data.push({x:flaw[0], y:flaw[2], total: flaw[4]}) //inicio falha
                data.push({x:flaw[1], y:flaw[3], total: flaw[4]}) //fim falha
                data.push({x:flaw[1]+1, y:null})
            })
            series.push(
                {
                    name: "Falhas",
                    data: data,
                    type: 'line',
                    id: "flaws",
                    color: 'red',
                    dashStyle: 'ShortDash',
                    zIndex: 0,
                    lineWidth:1
                }
            );
            
        }
        return series
    },
    generateTitles(station_prefix){
        if(station_prefix.station_type_id == 2){
            return { 
                title: "Eventos de chuva do Posto: " + station_prefix.prefix,
                subtitle: "Período com intervalor em minutos"
            }
        } else if(station_prefix.station_type_id == 1){
            return { 
                title: "Leituras (Cota/Vazão) do Posto: "+ station_prefix.prefix,
                subtitle: "Período com intervalor em minutos"
            }
        }
    },
    getFlaws(current_series, measurements, period, transmission_time){
        // flaw format start_timestamp, end_timestamp, start_value, end_value, minutes_of_flaw
        let start_ms = _series_helper.getShouldBeStartDate(period)
        let end_ms = _series_helper.getShouldBeEndDate(period)
        let prev_date = null
        let flaws = []
        $.each(measurements, function(index, measurement){
            if(prev_date != null){
                let date = new Date(measurement.date)
                let mss = date - prev_date
                let diff_in_minutes = Math.floor((mss/1000)/60);
                if(diff_in_minutes > transmission_time){
                    flaws.push([prev_date.getTime(), date.getTime(), 0,0,diff_in_minutes])
                }
                prev_date = new Date(measurement.date)
            } else {
                prev_date = new Date(measurement.date)
                let mss = prev_date.getTime() - start_ms
                let diff_in_minutes = Math.floor((mss/1000)/60);
                if(diff_in_minutes > transmission_time){
                    flaws.push([start_ms.getTime(), prev_date.getTime(), 0,0,diff_in_minutes])
                }
            }
            
        })
        let mss = end_ms.getTime() - prev_date.getTime()
        let diff_in_minutes = Math.floor((mss/1000)/60);
        console.log(diff_in_minutes)
        if(diff_in_minutes > 0){
            flaws.push([prev_date.getTime(), end_ms.getTime(), 0,0,diff_in_minutes])
        }
        console.log('flaws', flaws)
        return flaws
    },
    fillSeriesWithFlaws(flaws, serie){
        //que nojo disso aqui
        let s = [...serie]
        let indexes = []
        $.each(s, function(i, data){
            $.each(flaws, function(j, flaw){
                if(data[0] == flaw[0]){
                    indexes.push(i)
                }
            })
        })
        $.each(indexes, function(index, number){
            serie.splice(number+index+1, 0, [serie[number+index][0]+50, null]);
        })
        return serie
    },
    fillFlawsWithValues(flaws, series){
        if(flaws.length> 0){
            if(flaws[0][0] < series[0][0]){
                //falha anterior a qualquer medição, preencher com o valor da primeira medição
                flaws[0][2] = series[0][1]
            }
            if(flaws[flaws.length-1][1] > series[series.length-1][0]){
                flaws[flaws.length-1][3] = series[series.length-2][1] // pegando o valor da penultima medição, pois a ultima é a falha com value = null
            }
            $.each(flaws, function(index, flaw){
                $.each(series, function(index, serie){
                    if(serie[0] == flaw[0]){
                        flaw[2] = serie[1]
                    } else if(serie[0] == flaw[1]){
                        flaw[3] = serie[1]
                    } else {

                    }
                })
            })
        }
        
        return flaws
    },
    generatePlotLines(measurements){
        //LODASH LIB, INSTALADA PELO MONTEIRO, QUE BY THE WAY, NAO COMUNICOU ATÉ VER O TRABALHO DO REDUCE, é isso
        let min_level = _.min(measurements.map(x=>x.value))
        let max_level = _.max(measurements.map(x=>x.value))
        let avg_level = _.meanBy(measurements.map(x=>x.value)).toFixed(3)

        let min_flow = _.min(measurements.map(x=>x.read_value_flu))
        let max_flow = _.max(measurements.map(x=>x.read_value_flu))
        let avg_flow = _.meanBy(measurements.map(x=>x.read_value_flu)).toFixed(3)

        let _level_plots = {
            'Max': {color: '#04ba22',value:max_level,text: 'white'},
            'Media': {color: '#6fde7f', value: avg_level,text: 'white'},
            'Min': {color: '#daf7de',value:min_level, text: '#6e9173'}
        }
        let _flow_plots = {
            'Max': {color: '#f72579',value:max_flow,text: 'white'},
            'Media': {color: '#f06ea2', value: avg_flow,text: 'white'},
            'Min': {color: '#ffd1e4',value:min_flow, text: '#a35f7b'}
        }
        let ps = {'level':[], 'flow':[]}
        $.each(_level_plots, function(plot, options){
            ps['level'].push({
                color: options.color,
                width: 2,
                value: options.value,
                dashStyle: 'ShortDash',
                id:'param',
                label:{
                    text: "<span style='color:"+options.text+";background-color:"+options.color+";padding:2px;border-radius:7px;'>"+plot+" ("+options.value+") cm</span>",
                    style: {
                        fontWeight: 'bold'
                    },
                    useHTML: true
                }
            })
        })
        $.each(_flow_plots, function(plot, options){
            ps['flow'].push({
                color: options.color,
                width: 2,
                value: options.value,
                dashStyle: 'ShortDash',
                id:'param',
                label:{
                    text: "<span style='color:"+options.text+";background-color:"+options.color+";padding:2px;border-radius:7px'>"+plot+" ("+options.value+") m³/s</span>",
                    style: {
                        fontWeight: 'bold'
                    },
                    useHTML: true,
                    align:'right'
                }
            })
        })
        return ps
    },
    flawHumanize(value){
        value = Math.abs(value)
        if(value < 60){
            return value +' minutos';
        } else if(value < 1440){
            return (value/60).toFixed(1) +' horas';
        } else {
            return (value / 60 / 24).toFixed(2) +' dias';
        }
    },
    setStage(chart_container){
        if(this.chart_id == undefined){
            this.chart_id = "station-chart-" + (Math.random() + 1).toString(36).substring(7);
            $(chart_container).html("<div id='"+this.chart_id+"' style='width:100%;height:100%'></div><div class='overlay-container' style='"+this.overlayContainerStyle()+"'><div class='overlay' style='"+this.overlayStyle()+"'></div><div class='content' style='position:absolute'>"+spinners.sk_circle()+"</div></div>")
        } else {

        }
    },
    overlayContainerStyle(){
        let styles = [
            ['position', 'absolute'],
            ['width', '100%'],
            ['height', '100%'],
            ['top', '0'],
            ['opacity', '0'],
            ['visibility', 'hidden'],
            ['transition', '0.5s opacity'],
            ['display', 'flex'],
            ['align-items', 'center'],
            ['justify-content', 'center'],
        ]
        let html = ""
        $.each(styles,function(index, style){
            html += (style[0] +":" + style[1] + ";")
        })
        return html
    },
    overlayStyle(){
        let styles = [
            ['background-color', 'rgba(255,255,255,0.5)'],
            ['width', '100%'],
            ['height', '100%'],
        ]
        let html = ""
        $.each(styles,function(index, style){
            html += (style[0] +":" + style[1] + ";")
        })
        return html
    },
    showOverlay(chart_container){
        $(chart_container).find('.overlay-container').css({
            "opacity": "1",
            "visibility": "visible"
        })
    },
    hideOverlay(chart_container){
        $(chart_container).find('.overlay-container').css({
            "opacity": "0",
            "visibility": "hidden"
        })
    }
}

export default _CHART